import React from "react";

const RenderPerson = ({ person, isRequired = false }) => {
    let display = "Not specified";
    let warning = false;

    const title = person?.title || "";
    const firstName = person?.firstName || "";
    const initials = person?.initials || "";
    const lastName = person?.lastName || "";
    const name = `${title} ${firstName} ${initials} ${lastName}`.trim();

    if (name) {
        display = name;
    } else {
        if (isRequired) {
            warning = true;
        }
    }

    return <span className={warning ? "error" : ""}>{display}</span>;
};

export default RenderPerson;
